import React from 'react';
import ReactDOM from 'react-dom/client';
import {HelmetProvider} from 'react-helmet-async';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import './styles/index.css';
import './styles/reset.css';
import './styles/global.css';
import './styles/support.css';
import App from './App';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <HelmetProvider>
        <App/>
    </HelmetProvider>
);